import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleRequestReopen = async (event_id, dispatch) => {
  dispatch(setShowPreloader(true));
  const response = await AxiosPostMethod(`org/event/request-reopen`, { event_id });
  dispatch(setShowPreloader(false));

  if (response.status === 200) {
    SuccessToast("Re-open request submitted. Please contact admin for approval.");
    return true;
  }

  if (response.status === 401) HandleLogout();
  else ErrorToast(response.data?.message || "Unable to request re-open.");

  return null;
};

export default handleRequestReopen;
